import React from 'react';
import PropTypes from 'prop-types';
import {Box} from "@material-ui/core";

const TabContent = ({children}) => {

    return (
        <Box bgcolor={'common.white'} p={{ xs: 2, sm: 2, md: 2 }} borderRadius={'0 0 5px 5px'}>
            {children}
        </Box>
    );
};

TabContent.propTypes = {
    children: PropTypes.any,
};

TabContent.defaultProps = {
    children: null,
};

export default TabContent;